import { css } from "lit";
//#region src/styles/shared-input-styles.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Shared styles for all input elements:
* Used from pd-input, pd-select, pd-input-area, pd-range, pd-checkbox and pd-radio-group.
*/
var SharedInputStyles = css`
  /**
   * Label used for input, select, input-area, range and radio-group.
   * Not used in button, button-group, checkbox (may have a label...?), form-row, form-container
   */
  label {
    display: block;
    padding: var(--pd-input-label-padding, 0);
    color: var(--pd-input-label-col, var(--pd-default-dark-col));
    text-align: var(--pd-input-label-align, left);
    font-size: var(--pd-input-label-font-size, 0.9em);
    font-family: var(
      --pd-input-label-font-family,
      var(--pd-default-font-title-family)
    );
    /* No max-width - label width is controlled by parent container */
  }

  /**
   * Error box for input elements. Used for checkbox, radio-group, input, input-area, select, range
   */
  .error-box {
    display: block;
    color: var(--pd-default-error-col);
    background: var(--pd-default-error-light-col);
    border: 1px solid var(--pd-default-error-col);
    border-radius: var(--pd-radius-md);
    /* Width matches input field, with min-width for readability */
    width: var(--pd-input-field-width, 250px);
    min-width: 150px;
    box-sizing: border-box;
  }
  .error-box p {
    margin: 0;
    padding: var(--pd-spacing-xs) var(--pd-spacing-xs) var(--pd-spacing-xs)
      var(--pd-spacing-sm);
    font-size: 0.8rem;
  }

  /* gradient noch aufräumen */

  .gradient {
    background: linear-gradient(
      to bottom,
      var(--my-background-gradient-color) 0%,
      var(--my-background-color) 100%
    );
  }

  .error .gradient {
    background: linear-gradient(
      to bottom,
      var(--my-background-gradient-color) 10%,
      var(--pd-default-error-light-col) 100%
    );
  }

  .gradient[disabled] {
    background: linear-gradient(
      to bottom,
      var(--pd-default-disabled-light-col) 0%,
      var(--pd-default-disabled-col) 100%
    );
  }
`;
//#endregion
export { SharedInputStyles };
